export default "__VITE_ASSET__BmuO1qhq__"